<template>
	<el-dialog :visible="dialogVisible" @close="handleCloseDialog" width="70%" :close-on-click-modal="false"
		:close-on-press-escape="false">
		<!-- 标题 -->
		<template #title>
			<div class="order_status_dialog_title">{{$t("message.costatus.diatitle")}}</div>
		</template>
		<!-- 订单信息 -->
		<el-row :gutter="10">
			<!-- 左边列 -->
			<el-col :lg="8" :md="12">
				<!-- 订单号 -->
				<div class="order_status_dialog_detail">
					<span>{{$t("message.costatus.info1")}}</span>
					<span>{{order_detail.order_sn}}</span>
				</div>
				<!-- 订单状态 -->
				<div class="order_status_dialog_detail">
					<span>{{$t("message.costatus.info2")}}</span>
					<span>{{{val:order_detail.order_status,lang:$t("message.costatus")} | orderStatus}}</span>
				</div>
				<!-- 状态修改下拉菜单 -->
				<div class="order_status_dialog_detail" v-if="examine>0">
					<span>{{$t("message.costatus.info3")}}</span>
					<!-- 打单员可视部分 -->
					<span v-if="examine===4">{{$t("message.costatus.info4")}}</span>
					<span v-else-if="examine==2">{{$t("message.costatus.info5")}}</span>
					<!-- 审核员操作部分 -->
					<el-select v-model="select_status" size="mini" v-else>
						<el-option v-for="(item, index) in statusOptions" :key="index" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<!-- 签收图片 -->
				<div class="order_status_dialog_detail">
					<span>{{$t("message.costatus.info6")}}</span>
					<ul class="order_status_dialog_img_list clearfix" v-if="!!order_detail.sign_picture">
						<li v-for="(item, index) in order_detail.sign_picture" :key="index"
							@mouseenter="handleEnter('sign', index)" @mouseleave="handleLeave('sign')">
							<!-- 图片 -->
							<div :class="[
                                    'order_status_dialog_img',
                                    {order_status_dialog_img_hover: hover_sign == index}
                                ]">
								<img :src="item" alt="">
							</div>
							<transition name="fade">
								<!-- 放大镜 -->
								<el-button type="text" @click="handleOpenInnerDialog(item)"
									class="order_status_dialog_magnifier" v-if="hover_sign == index">
									<i class="el-icon-zoom-in"></i>
								</el-button>
							</transition>
							<transition name="fade">
								<!-- 下载按钮 -->
								<a :href="item" class="order_status_dialog_download" v-if="hover_sign == index"
									target="view_window">
									<i class="el-icon-download"></i>
								</a>
							</transition>
						</li>
					</ul>
					<span class="order_status_dialog_detail_nothing" v-else>{{$t("message.costatus.nothing1")}}</span>
				</div>
			</el-col>
			<!-- 中间列 -->
			<el-col :lg="8" :md="12">
				<!-- 用户名 -->
				<div class="order_status_dialog_detail">
					<span>{{$t("message.costatus.info7")}}</span>
					<span>{{order_detail.userID}}</span>
				</div>
				<!-- 下单时间 -->
				<div class="order_status_dialog_detail">
					<span>{{$t("message.costatus.info8")}}</span>
					<span>{{order_detail.createtime}}</span>
				</div>
				<!-- 处理说明 -->
				<div class="order_status_dialog_detail" v-if="[1,2,3,4].includes(examine)">
					<span>{{$t("message.costatus.info9")}}</span>
					<el-input size="mini" v-model="explain" class="order_status_dialog_detail_explain">
					</el-input>
				</div>
				<!-- PDF底单 -->
				<div class="order_status_dialog_detail">
					<span>{{$t("message.costatus.info10")}}</span>
					<ul class="order_status_dialog_PDF_list clearfix" v-if="!!order_detail.PDF_bottom_sheet">
						<li v-for="(item, index) in order_detail.PDF_bottom_sheet" :key="index">
							<!-- 图片 -->
							<img src="../../assets/img/images/pdf.png" style="width: 30px; height: 30px;" />
							<a :href="item" target="view_window">
								{{$t("message.costatus.download")}}
							</a>
						</li>
					</ul>
					<span class="order_status_dialog_detail_nothing" v-else>{{$t("message.costatus.nothing1")}}</span>
				</div>
			</el-col>
			<!-- 右边列 -->
			<el-col :lg="8" :md="24">
				<div>{{$t("message.costatus.info11")}}</div>
				<!-- 步骤组件 -->
				<el-steps direction="vertical" v-if="order_log.length">
					<el-step v-for="(item, index) in order_log" :key="index" :title="item.end_time">
						<template #description>
							<div v-if="!!item.content">{{item.content}}</div>
							<div v-else>{{$t("message.costatus.nothing2")}}</div>
						</template>
					</el-step>
				</el-steps>
				<div class="order_status_dialog_nolog" v-else>{{$t("message.costatus.nothing1")}}</div>
			</el-col>
		</el-row>
		<!-- 收货地址 & 其他说明 -->
		<div class="order_status_dialog_address">
			<div>
				<!-- 收货地址 -->
				<div>
					<span>{{$t("message.costatus.info12")}}</span>
					<span>{{order_detail.address}}</span>
				</div>
				<!-- 其他说明 -->
				<div>
					<span>{{$t("message.costatus.info13")}}</span>
					<span v-if="!!order_detail.postscript">{{order_detail.postscript}}</span>
					<span class="order_status_dialog_detail_nothing" v-else>{{$t("message.costatus.nothing1")}}</span>
				</div>
			</div>
			<div>
				<!-- 姓名 -->
				<div>
					<span>{{$t("message.costatus.info14")}}</span>
					<span>{{order_detail.consignee}}</span>
				</div>
				<!-- 電話 -->
				<div>
					<span>{{$t("message.costatus.info15")}}</span>
					<span>{{order_detail.mobile}}</span>
				</div>
				<!-- 部門 -->
				<div>
					<span>{{$t("message.costatus.info16")}}</span>
					<span>{{order_detail.departmentname}}</span>
				</div>
			</div>

		</div>
		<!-- 商品部分 -->
		<order-goods :remark="explain" :status="select_status"></order-goods>
		<!-- 内层模态框 -->
		<el-dialog :visible="innerDialogVisible" @close="handleCloseInnerDialog" append-to-body>
			<img :src="inner_img" class="order_status_innerdialog_img" alt="">
		</el-dialog>
	</el-dialog>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'

	export default {
		filters: {
			// 模态框订单状态过滤器
			orderStatus({
				val,
				lang
			}) {
				switch (val) {
					case '0':
						return lang.filter14;
						break;
					case '1':
						return lang.filter15;
						break;
					case '2':
						return lang.filter16;
						break;
					case '3':
						return lang.filter17;
						break;
					case '4':
						return lang.filter18;
						break;
					case '5':
						return lang.filter19;
						break;
					case '6':
						return lang.filter20;
						break;
					case '7':
						return lang.filter21;
						break;
					case '8':
						return lang.filter22;
						break;
				}
			},
		},
		data() {
			return {
				select_status: "", // 状态修改绑定值
				examine_options: [{
						value: 0,
						label: this.$t("message.costatus.examine1")
					},
					{
						value: 1,
						label: this.$t("message.costatus.examine2")
					},
				], //审核选项
				modify_options: [{
						value: 0,
						label: this.$t("message.costatus.examine3")
					},
					{
						value: 1,
						label: this.$t("message.costatus.examine4")
					},
				], //申请修改选项
				explain: "", // 处理说明
				hover_sign: -1, // 当前悬停签收图片
				hover_PDF: -1, // 当前悬停PDF图片
				inner_img: "", // 内层模态框图片
			}
		},
		computed: mapState({
			dialogVisible: state => state.dialogVisible,
			innerDialogVisible: state => state.innerDialogVisible,
			order_detail: state => state.order.order_detail,
			order_log: state => state.order.order_log,
			examine: state => state.order.examine, // 审核状态
			statusOptions() {
				let options = [];
				if (this.examine == 1) {
					options = this.examine_options;
				} else if (this.examine == 3) {
					options = this.modify_options;
				}
				return options;
			}
		}),
		components: {
			orderGoods: () => import("@/components/center/orderStatusDialogGoods")
		},
		methods: {
			...mapMutations([
				"handleDialog",
				"handleInnerDialog",
				"clearOrderStatusDetail"
			]),
			handleCloseDialog() { // 关闭模态框
				this.handleDialog(false);
				this.clearOrderStatusDetail();
				this.select_status = "";
				this.explain = "";
			},
			handleOpenInnerDialog(val) { // 打开内层模态框
				this.inner_img = val;
				this.handleInnerDialog(true);
			},
			handleCloseInnerDialog() { // 关闭内层模态框
				this.handleInnerDialog(false);
				this.inner_img = "";
			},
			handleEnter(where, index) { // 鼠标悬停
				if (where == "sign") {
					this.hover_sign = index;
				} else {
					this.hover_PDF = index;
				}
			},
			handleLeave(where) { // 鼠标离开
				if (where == "sign") {
					this.hover_sign = -1;
				} else {
					this.hover_PDF = -1
				}
			}
		},
	}
</script>

<style scoped>
	/* 模态框标题 */
	.order_status_dialog_title {
		font-size: 20px;
		font-weight: bold;
		color: #303133;
	}

	/* 订单信息行 */
	.order_status_dialog_detail {
		margin-bottom: 5px;
	}

	/* 处理说明输入框 */
	.order_status_dialog_detail_explain {
		width: 190px;
	}

	/* 订单图片容器 */
	.order_status_dialog_img_list {
		border: 1px dashed #EBEEF5;
	}

	.order_status_dialog_img_list>li {
		position: relative;
		float: left;
		width: 21%;
		margin: 5px;
		border: 1px solid #DCDFE6;
	}

	.order_status_dialog_img_list>li::before {
		display: block;
		content: "";
		padding-top: 100%;
	}

	/* pdf */
	.order_status_dialog_PDF_list>li {
		float: left;
		margin: 5px;
	}

	/* 公共样式 */
	.order_status_dialog_img>img,
	.order_status_dialog_magnifier,
	.order_status_dialog_download {
		position: absolute;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	/* 图片 */
	.order_status_dialog_img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.order_status_dialog_img>img {
		left: 50%;
		max-width: 100%;
		max-height: 100%;
	}

	/* 悬停图片时 */
	.order_status_dialog_img_hover {
		filter: brightness(30%);
		transition: all .1s linear;
	}

	/* 放大镜 */
	.order_status_dialog_magnifier {
		left: 30%;
	}

	/* 下载按钮 */
	.order_status_dialog_download {
		left: 70%;
		color: #ff6700;
	}

	/* 按钮过渡动画 */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .1s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	/* 没有参数状态 */
	.order_status_dialog_detail_nothing {
		margin-left: 15px;
		color: #C0C4CC;
	}

	/* 无流程说明 */
	.order_status_dialog_nolog {
		margin-top: 5px;
		padding-left: 20px;
		color: #C0C4CC;
	}

	/* 收货地址 & 其他说明 */
	.order_status_dialog_address {
		margin: 10px 0;
		padding: 10px 0;
		border-top: 1px dashed #DCDFE6;
		border-bottom: 1px dashed #DCDFE6;
	}

	/* 内层模态框图片 */
	.order_status_innerdialog_img {
		width: 100%;
	}
</style>
